import {i18n} from "@lingui/core";

export const locales = {
    en: "English",
    cs: "Česky",
} as const;

// const SupportedLocale = Object.keys(locales);

export const defaultLocale = "en";

export async function dynamicActivate(locale: string) {
    const { messages } = await import(`./locales/${locale}/messages.po`);
    i18n.loadAndActivate({locale, messages});
    // i18n.load(locale, messages);
    // i18n.activate(locale);
}
